import {SET_PAYMENT_METHOD, SET_INVOICE_DATA, SET_PAYMENT_DATA} from '../costants/ActionTypes'

const initialState = {
  method: "cash",
  title: "Наличными",
  variants: {
      "cash": {id: 1, title: "Наличными", img: "https://www.tdpra.ru/media/plugins_media/2016/3/11/cash.png"},
      "card": {id: 2, title: "Банковской картой", description: "процессинг ПАО Сбербанк",
          img: "https://www.tdpra.ru/media/plugins_media/2016/3/11/viza.png"},
      "invoice": {id: 3, title: "Счет на оплату",
          img: "https://www.tdpra.ru/media/plugins_media/2016/3/11/paper.png",
          data: {
          name: "",
          inn: "",
          kpp: "",
          ogrn: "",
          address: "",
          phone: "",
          real_address: "",
          org_schet: "",
          bank: "",
          bik: "",
          bank_schet: "",
          same_address: true,
          }
      }
  }
}

const npayment = (state = initialState, action) => {

  switch (action.type) {

      case SET_PAYMENT_METHOD:
          return Object.assign({}, state, {
              method: action.method,
              title: action.title
          })

      case SET_PAYMENT_DATA:
          return Object.assign({}, state, action.data);

      case SET_INVOICE_DATA:
          let invoice_data = Object.assign({}, state.variants.invoice.data, action.data);
          let invoice = Object.assign({}, state.variants.invoice, {"data": invoice_data});
          let variants = Object.assign({}, state.variants, {"invoice": invoice});
          return Object.assign({}, state, {'variants': variants});

      default:
        return state
  }
}

export default npayment